import { useEffect, useRef } from 'react'

/**
 * Custom hook that manages the layout readiness state of a component.
 * @param {Function} callback - Optional callback function to be executed when the component unmounts.
 * @returns {Object} An object containing the `isLayoutReady` state.
 */
export const useLayoutEffects = (callback?: () => void) => {
    const isComponentReady = useRef(false)

    // Side-effect that resets the workspace store when component unmounted
    useEffect(() => {
        if (!isComponentReady.current) {
            isComponentReady.current = true
        }

        return () => {
            isComponentReady.current = false
            callback?.()
        }
    }, [isComponentReady.current])

    return { isComponentReady: isComponentReady.current }
}
